var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssignmentNew = function SvgAssignmentNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.667 28a2.568 2.568 0 0 1-1.884-.783A2.568 2.568 0 0 1 4 25.333V6.667c0-.734.261-1.361.783-1.884A2.568 2.568 0 0 1 6.667 4h5.6c.289-.8.772-1.444 1.45-1.933A3.809 3.809 0 0 1 16 1.333c.844 0 1.606.245 2.283.734A4.004 4.004 0 0 1 19.733 4h5.6c.734 0 1.361.261 1.884.783.522.523.783 1.15.783 1.884V15.6c-.422-.2-.856-.372-1.3-.517-.444-.144-.9-.25-1.367-.316v-8.1H6.667v18.666h8.066c.067.49.173.956.317 1.4.144.445.317.867.517 1.267h-8.9Zm0-2.667V6.667v8.1-.1 10.666Zm2.666-2.666h5.434c.066-.467.172-.923.316-1.367.145-.444.306-.878.484-1.3H9.333v2.667Zm0-5.334h8.134a10.207 10.207 0 0 1 2.383-1.666 9.391 9.391 0 0 1 2.817-.9v-.1H9.333v2.666Zm0-5.333h13.334V9.333H9.333V12ZM16 5.667a.971.971 0 0 0 .717-.284.971.971 0 0 0 .283-.716.971.971 0 0 0-.283-.717.971.971 0 0 0-.717-.283.971.971 0 0 0-.717.283.971.971 0 0 0-.283.717c0 .289.094.527.283.716a.971.971 0 0 0 .717.284Zm8 25c-1.844 0-3.417-.65-4.717-1.95-1.3-1.3-1.95-2.872-1.95-4.717 0-1.844.65-3.417 1.95-4.717 1.3-1.3 2.873-1.95 4.717-1.95 1.844 0 3.417.65 4.717 1.95 1.3 1.3 1.95 2.873 1.95 4.717 0 1.845-.65 3.417-1.95 4.717-1.3 1.3-2.873 1.95-4.717 1.95ZM23.333 28h1.334v-3.333H28v-1.334h-3.333V20h-1.334v3.333H20v1.334h3.333V28Z",
    fill: "#F92"
  }))));
};
export default SvgAssignmentNew;